import { Edit } from '@mui/icons-material';
import { Box, IconButton, Typography } from '@mui/material';
import React, { ReactNode } from 'react';
import TypeChip from '../chip/TypeChip';
import ExerciseType from '../exercise-type/ExerciseType';
import { ExerciseType as IExerciseType, SimulatorType } from '../types';
import { useDesktop } from '../useDesktop';

export interface ExerciseHeaderProps {
  onClickEdit?: () => void;
  name: string;
  simulatorType: SimulatorType;
  startButton?: ReactNode;
  title: string;
  type: IExerciseType;
}

const ExerciseHeader = ({ name, simulatorType, title, type, onClickEdit, startButton }: ExerciseHeaderProps) => {
  const isDesktop = useDesktop();

  return (
    <>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap', mb: 2 }}>
        <ExerciseType type={type} />
        <TypeChip size="small" type={simulatorType} />
        <Box flex={1}></Box>
        {startButton}
      </Box>
      <Box alignItems="center" display="flex" gap={4} mb={2}>
        <Typography component="h1" variant={isDesktop ? 'h4' : 'h5'}>
          {title}
        </Typography>
        {onClickEdit && (
          <IconButton onClick={onClickEdit}>
            <Edit />
          </IconButton>
        )}
      </Box>
      <Typography color={{ sm: 'text.secondary' }} component="div" variant={isDesktop ? 'body1' : 'body2'} mb={2}>
        {name}
      </Typography>
    </>
  );
};

export default ExerciseHeader;
